var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoicemailActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-voicemail_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "voicemail_2",
    "data-name": "voicemail \\u2013 2",
    clipPath: "url(#clip-voicemail_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Voicemail_copy_3",
    "data-name": "Voicemail copy 3",
    d: "M178.741,57.623v.007h16.576v-.007a6.9,6.9,0,1,0-6.655-6.885,8.389,8.389,0,0,0,.6,3.22l-4.781.006A6.289,6.289,0,0,0,185.5,50.63a6.518,6.518,0,1,0-6.759,6.993Zm16.323-10.858a3.985,3.985,0,1,1-3.69,3.974A3.845,3.845,0,0,1,195.064,46.765ZM179,46.639a4,4,0,1,1-3.707,3.992A3.862,3.862,0,0,1,179,46.639Z",
    transform: "translate(-171.5 -34.63)",
    fill: "#8bc500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicemailActive);
export default __webpack_public_path__ + "static/media/voicemail_active.79ec869487603ff71c57e4d2ce207f28.svg";
export { ForwardRef as ReactComponent };